function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import _styled6 from "styled-components";
import _styled5 from "styled-components";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
var _excluded = ["item"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BasicButton } from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-helpers';
import Icon from '@adsk/alloy-react-icon';
import theme, { getInteractiveStyles } from '@adsk/alloy-react-theme';
import { defaultValueRenderer, defaultValueTagRenderer } from './defaultRenderers';
/**
 * SelectBoxControl
 */

var SelectBoxControl = /*#__PURE__*/function (_Component) {
  _inherits(SelectBoxControl, _Component);

  var _super = _createSuper(SelectBoxControl);

  function SelectBoxControl(props) {
    var _this;

    _classCallCheck(this, SelectBoxControl);

    _this = _super.call(this, props);
    _this.handleControlClick = _this.handleControlClick.bind(_assertThisInitialized(_this));
    _this.handleSearchClear = _this.handleSearchClear.bind(_assertThisInitialized(_this));
    _this.handleMenuToggle = _this.handleMenuToggle.bind(_assertThisInitialized(_this));
    _this.getValueTagProps = _this.getValueTagProps.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SelectBoxControl, [{
    key: "handleControlClick",
    value: function handleControlClick(e) {
      e.stopPropagation();
      var _this$props = this.props,
          disabled = _this$props.disabled,
          searchable = _this$props.searchable,
          stateAndHelpers = _this$props.stateAndHelpers;
      var isOpen = stateAndHelpers.isOpen,
          openMenu = stateAndHelpers.openMenu,
          closeMenu = stateAndHelpers.closeMenu;
      if (disabled) return;

      if (!searchable) {
        isOpen ? closeMenu() : openMenu();
      } else if (!isOpen) {
        openMenu();
      }
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(e) {
      e.preventDefault();
    }
  }, {
    key: "handleSearchClear",
    value: function handleSearchClear() {
      var _this$props2 = this.props,
          stateAndHelpers = _this$props2.stateAndHelpers,
          onInputChange = _this$props2.onInputChange;
      stateAndHelpers.setState({
        inputValue: ''
      }, function () {
        onInputChange('', stateAndHelpers);
      });
    }
  }, {
    key: "handleMenuToggle",
    value: function handleMenuToggle(e) {
      var _this$props$stateAndH = this.props.stateAndHelpers,
          isOpen = _this$props$stateAndH.isOpen,
          closeMenu = _this$props$stateAndH.closeMenu;

      if (isOpen) {
        e.preventDefault();
        closeMenu();
      }
    }
  }, {
    key: "handleValueTagRemove",
    value: function handleValueTagRemove(item) {
      var _this$props3 = this.props,
          stateAndHelpers = _this$props3.stateAndHelpers,
          multiple = _this$props3.multiple,
          selectedValue = _this$props3.selectedValue,
          valueKey = _this$props3.valueKey;
      var isOpen = stateAndHelpers.isOpen,
          inputValue = stateAndHelpers.inputValue;

      if (multiple) {
        stateAndHelpers.selectItem(selectedValue.filter(function (x) {
          return x[valueKey] !== item[valueKey];
        }), {
          isOpen: isOpen,
          inputValue: inputValue
        });
      } else if (selectedValue && selectedValue[valueKey] === item[valueKey]) {
        stateAndHelpers.clearSelection();
      }
    }
  }, {
    key: "getValueTagProps",
    value: function getValueTagProps(_ref) {
      var _this2 = this;

      var item = _ref.item,
          rest = _objectWithoutProperties(_ref, _excluded);

      var eventHandlers = {
        onMouseDown: function onMouseDown(e) {
          e.preventDefault();
        },
        onClick: function onClick(e) {
          e.stopPropagation();

          _this2.handleValueTagRemove(item);
        }
      };
      return _objectSpread(_objectSpread({}, eventHandlers), rest);
    }
  }, {
    key: "renderPlaceholder",
    value: function renderPlaceholder() {
      var isOpen = this.props.stateAndHelpers.isOpen;
      var _this$props4 = this.props,
          searchable = _this$props4.searchable,
          _this$props4$placehol = _this$props4.placeholder,
          placeholder = _this$props4$placehol === void 0 ? this.props['T'].translate('SELECT') : _this$props4$placehol,
          _this$props4$searchPl = _this$props4.searchPlaceholder,
          searchPlaceholder = _this$props4$searchPl === void 0 ? this.props['T'].translate('SEARCH') : _this$props4$searchPl;
      var inputPlaceholder = isOpen && searchable ? searchPlaceholder : placeholder;
      return /*#__PURE__*/React.createElement(_StyledDiv, {
        $_css: [theme.typography.labelMedium, {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          color: theme.colors.charcoal500,
          position: 'absolute',
          left: 0,
          right: 0,
          top: '50%',
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
          userSelect: 'none'
        }]
      }, inputPlaceholder);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this3 = this;

      var _this$props5 = this.props,
          stateAndHelpers = _this$props5.stateAndHelpers,
          autoFocus = _this$props5.autoFocus,
          searchable = _this$props5.searchable,
          multiple = _this$props5.multiple,
          selectedValue = _this$props5.selectedValue,
          showValueAsTags = _this$props5.showValueAsTags;
      var getInputProps = stateAndHelpers.getInputProps,
          inputValue = stateAndHelpers.inputValue;
      return /*#__PURE__*/React.createElement(_StyledInput, _extends({
        "data-testid": "SelectBox__input",
        dir: 'auto'
      }, getInputProps({
        autoFocus: searchable && autoFocus,
        autoComplete: 'off',
        onKeyDown: function onKeyDown(event) {
          if (event.key === 'Backspace' && searchable && showValueAsTags && !inputValue) {
            if (multiple && selectedValue.length > 0) {
              _this3.handleValueTagRemove(selectedValue[selectedValue.length - 1]);
            } else if (!multiple && selectedValue) {
              _this3.handleValueTagRemove(selectedValue);
            }
          }
        }
      })));
    }
  }, {
    key: "renderValue",
    value: function renderValue() {
      var _this$props6 = this.props,
          stateAndHelpers = _this$props6.stateAndHelpers,
          isSelected = _this$props6.isSelected,
          selectedValue = _this$props6.selectedValue,
          searchable = _this$props6.searchable,
          _this$props6$valueRen = _this$props6.valueRenderer,
          valueRenderer = _this$props6$valueRen === void 0 ? defaultValueRenderer : _this$props6$valueRen;
      var isOpen = stateAndHelpers.isOpen;
      if (!isSelected || searchable && isOpen) return null;
      return valueRenderer(selectedValue, this.props);
    }
  }, {
    key: "renderValueTags",
    value: function renderValueTags() {
      var _this$props7 = this.props,
          stateAndHelpers = _this$props7.stateAndHelpers,
          selectedValue = _this$props7.selectedValue,
          container = _this$props7.container,
          disabled = _this$props7.disabled,
          searchable = _this$props7.searchable,
          multiple = _this$props7.multiple,
          _this$props7$valueTag = _this$props7.valueTagRenderer,
          valueTagRenderer = _this$props7$valueTag === void 0 ? defaultValueTagRenderer : _this$props7$valueTag;
      var isOpen = stateAndHelpers.isOpen;

      var _stateAndHelpers = _objectSpread(_objectSpread({}, stateAndHelpers), {}, {
        getValueTagProps: this.getValueTagProps
      });

      var _props = _objectSpread(_objectSpread({}, this.props), {}, {
        stateAndHelpers: _stateAndHelpers,
        container: container || this
      });

      return /*#__PURE__*/React.createElement(_StyledDiv2, null, multiple && selectedValue.map(function (item) {
        return valueTagRenderer(item, _props);
      }), !multiple && selectedValue && !(searchable && isOpen) && valueTagRenderer(selectedValue, _props), !disabled && searchable && isOpen && this.renderInput());
    }
  }, {
    key: "renderToggle",
    value: function renderToggle() {
      var _this$props8 = this.props,
          disabled = _this$props8.disabled,
          searchable = _this$props8.searchable,
          multiple = _this$props8.multiple,
          stateAndHelpers = _this$props8.stateAndHelpers;
      var isOpen = stateAndHelpers.isOpen,
          inputValue = stateAndHelpers.inputValue;

      if (isOpen && searchable && multiple && !!inputValue) {
        return /*#__PURE__*/React.createElement(BasicButton, {
          "data-testid": "SelectBox__toggle",
          onMouseDown: this.handleMouseDown,
          onClick: this.handleSearchClear,
          style: {
            color: theme.colors.charcoal900,
            padding: '0 6',
            border: 0,
            '&:hover': {
              color: theme.colors.adskBlue700
            }
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          size: 20,
          type: Icon.TYPES.X,
          style: isOpen && {
            marginRight: 2,
            transform: 'rotate(180deg)'
          }
        }));
      }

      return /*#__PURE__*/React.createElement(BasicButton, {
        "data-testid": "SelectBox__toggle",
        style: {
          color: '#DAE1E6'
        },
        onClick: !disabled && searchable ? this.handleMenuToggle : undefined
      }, /*#__PURE__*/React.createElement(Icon, {
        size: 24,
        type: Icon.TYPES.CHEVRON_DOWN,
        style: _objectSpread(_objectSpread({}, isOpen && {
          transform: 'rotate(180deg)'
        }), disabled ? {
          color: theme.colors.charcoal500
        } : {
          color: theme.colors.charcoal900
        })
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          className = _this$props9.className,
          style = _this$props9.style,
          stateAndHelpers = _this$props9.stateAndHelpers,
          isSelected = _this$props9.isSelected,
          disabled = _this$props9.disabled,
          invalid = _this$props9.invalid,
          searchable = _this$props9.searchable,
          multiple = _this$props9.multiple,
          showValueAsTags = _this$props9.showValueAsTags,
          showSearchIcon = _this$props9.showSearchIcon,
          innerRef = _this$props9.innerRef;
      var getLabelProps = stateAndHelpers.getLabelProps,
          isOpen = stateAndHelpers.isOpen,
          inputValue = stateAndHelpers.inputValue;
      var showSearch = searchable && showSearchIcon && !(!isOpen && isSelected) && !showValueAsTags;
      var showPlaceHolder = !isSelected && !inputValue || isSelected && !inputValue && isOpen && searchable && !(showValueAsTags && multiple);
      var showInput = !disabled && !showValueAsTags && searchable && isOpen;
      return /*#__PURE__*/React.createElement(_StyledLabel, _extends({
        className: className,
        ref: innerRef,
        "data-testid": "SelectBox__control",
        onClick: this.handleControlClick
      }, getLabelProps(), {
        $_css2: [theme.typography.labelMedium, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
          position: 'relative',
          display: 'flex',
          cursor: 'pointer',
          backgroundColor: theme.colors.white,
          borderColor: theme.colors.charcoal400,
          borderRadius: 2,
          borderStyle: 'solid',
          borderWidth: 1,
          minHeight: 36,
          margin: 0,
          padding: 0
        }, getInteractiveStyles(disabled)), isOpen && {
          borderColor: theme.colors.adskBlue500,
          boxShadow: "0 0 0 2px ".concat(theme.colors.focusHalo),
          '&:hover': {
            boxShadow: "0 0 0 2px ".concat(theme.colors.focusHalo)
          }
        }), disabled && {
          backgroundColor: theme.colors.charcoal050,
          borderColor: theme.colors.charcoal200,
          cursor: 'default',
          pointerEvents: 'none'
        }), invalid && !disabled && {
          borderColor: theme.colors.red500
        }), style]
      }), showSearch && /*#__PURE__*/React.createElement(_StyledDiv3, null, /*#__PURE__*/React.createElement(Icon, {
        type: Icon.TYPES.MAGNIFYING_GLASS,
        size: 15
      })), /*#__PURE__*/React.createElement(_StyledDiv4, null, showPlaceHolder && this.renderPlaceholder(), showInput && this.renderInput(), showValueAsTags ? this.renderValueTags() : this.renderValue()), this.renderToggle());
    }
  }]);

  return SelectBoxControl;
}(Component);

SelectBoxControl.displayName = 'SelectBoxControl';
SelectBoxControl.propTypes = {
  /**
   * Class name for the component
   */
  className: PropTypes.string,

  /**
   * style for the component
   */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),

  /**
   * i18n helper for T.translate('KEY')
   */
  T: PropTypes.object,

  /**
   * Whether the component is disabled
   */
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),

  /**
   * Whether the component is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Whether the component is invalid
   */
  invalid: PropTypes.bool,

  /**
   * Whether the component is searchable
   */
  searchable: PropTypes.bool,

  /**
   * stateAndHelpers pass to control from select
   */
  stateAndHelpers: PropTypes.shape({
    isOpen: PropTypes.bool,
    openMenu: PropTypes.func,
    closeMenu: PropTypes.func,
    selectItem: PropTypes.func,
    setState: PropTypes.func,
    clearSelection: PropTypes.func,
    getLabelProps: PropTypes.func,
    getInputProps: PropTypes.func,
    type: PropTypes.string,
    inputValue: PropTypes.string
  }),

  /**
   * `(inputValue, stateAndHelpers) => *`, callback when searching
   */
  onInputChange: PropTypes.func,

  /**
   * Whether the component is multi selectable
   */
  multiple: PropTypes.bool,

  /**
   * selectedValue
   */
  selectedValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /**
   * The key of the option value
   */
  valueKey: PropTypes.string,

  /**
   * The placeholder for the component
   */
  placeholder: PropTypes.node,

  /**
   * The placeholder for the component when searching
   */
  searchPlaceholder: PropTypes.node,

  /**
   * Whether the component is focused on mount
   */
  autoFocus: PropTypes.bool,

  /**
   * Whether the item is Selected
   */
  isSelected: PropTypes.bool,

  /**
   * func called on render value
   */
  valueRenderer: PropTypes.func,

  /**
   * Container for the menu, the menu would be rendered on an overlay if set
   */
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),

  /**
   * `(item, selectProps) => node`, custom value tag renderer
   */
  valueTagRenderer: PropTypes.func,

  /**
   * Whether to show value as tags
   */
  showValueAsTags: PropTypes.bool,

  /**
   * Whether to show search icon
   */
  showSearchIcon: PropTypes.bool
};

var WrapperSelectBoxControl = function WrapperSelectBoxControl(props) {
  var _useLocale = useLocale(function (_ref2) {
    var locale = _ref2.locale;
    return require("../i18n/".concat(locale, ".json"));
  }),
      T = _useLocale.T;

  return /*#__PURE__*/React.createElement(SelectBoxControl, _extends({}, props, {
    T: T
  }));
};

export default WrapperSelectBoxControl;

var _StyledDiv = _styled("div").withConfig({
  displayName: "SelectBoxControl___StyledDiv",
  componentId: "sc-1phkssy-0"
})(["", ""], function (p) {
  return p.$_css;
});

var _StyledInput = _styled("input").withConfig({
  displayName: "SelectBoxControl___StyledInput",
  componentId: "sc-1phkssy-1"
})(_defineProperty({
  backgroundColor: 'transparent',
  border: 'none',
  outline: 'none',
  padding: 0,
  textAlign: 'left',
  flex: 'auto'
}, '&::-ms-clear', {
  display: 'none'
}));

var _StyledDiv2 = _styled("div").withConfig({
  displayName: "SelectBoxControl___StyledDiv2",
  componentId: "sc-1phkssy-2"
})({
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%',
  height: '100%'
});

var _StyledLabel = _styled("label").withConfig({
  displayName: "SelectBoxControl___StyledLabel",
  componentId: "sc-1phkssy-3"
})(["", ""], function (p) {
  return p.$_css2;
});

var _StyledDiv3 = _styled("div").withConfig({
  displayName: "SelectBoxControl___StyledDiv3",
  componentId: "sc-1phkssy-4"
})({
  display: 'flex',
  alignItems: 'center',
  color: '#819099',
  padding: '1px 0 0 5px'
});

var _StyledDiv4 = _styled("div").withConfig({
  displayName: "SelectBoxControl___StyledDiv4",
  componentId: "sc-1phkssy-5"
})({
  position: 'relative',
  width: '100%',
  marginLeft: 16,
  padding: '3px 0',
  overflowX: 'hidden',
  display: 'flex',
  alignItems: 'center'
});
//# sourceMappingURL=SelectBoxControl.js.map